module.exports = __webpack_public_path__ + "static/media/video-bg.54be08ee.jpg";